import React, { useEffect, useMemo, useState } from 'react';
import Text from 'components/Text/Text';
import SearchField from 'components/SearchField/SearchField';
import OutsideFormSelect from 'components/Select/OutsideFormSelect';
import { Checkbox } from 'antd';
import { IItemForGetShortInfo } from 'types';
import style from './MultipleSelect.module.scss';

interface IMultipleSelect {
	data: IItemForGetShortInfo[];
	isLoading: boolean;
	refetch: () => void;
	responseError: boolean;
	isApplyToOne: boolean;
	setAdditionalRestaurants: (value: string[]) => void;
	selectedAdditionalRestaurants: string[];
	isVisibleAdditionalRestaurantsModal: boolean;
}

const MultipleSelect: React.FC<IMultipleSelect> = ({
	data,
	isLoading,
	refetch,
	responseError,
	isApplyToOne,
	setAdditionalRestaurants,
	selectedAdditionalRestaurants,
	isVisibleAdditionalRestaurantsModal,
}) => {
	const [searchString, setSearchString] = useState<string>('');
	const [isSelectedAllRestaurants, setIsSelectedAllRestaurants] = useState<boolean>(false);

	const filteredRestaurants = useMemo(() => {
		return searchString ? data.filter((el) => el.name.toLowerCase().includes(searchString.toLowerCase())) : data;
	}, [searchString, data]);

	const handleSelectAllRestaurants = () => {
		if (isSelectedAllRestaurants) {
			setAdditionalRestaurants([]);
		} else {
			const IDsOfAllRestaurants = data.map((el) => el.id);
			setAdditionalRestaurants(IDsOfAllRestaurants);
		}
	};

	useEffect(() => {
		setSearchString('');
	}, [isVisibleAdditionalRestaurantsModal]);

	useEffect(() => {
		if (selectedAdditionalRestaurants.length === 0) {
			setIsSelectedAllRestaurants(false);
		} else if (selectedAdditionalRestaurants.length === data.length) {
			setIsSelectedAllRestaurants(true);
		} else if (selectedAdditionalRestaurants.length !== data.length) {
			setIsSelectedAllRestaurants(false);
		}
	}, [selectedAdditionalRestaurants.length, data.length]);

	const renderSelectMenu = (menu: React.ReactElement) => {
		return (
			<>
				<div className={style.selectMenuHeader}>
					<Checkbox
						className={style.checkBox}
						checked={isSelectedAllRestaurants}
						disabled={!data.length}
						onChange={handleSelectAllRestaurants}>
						<Text translationNameSpace="form" translationKey="selectAnyItemPlaceholder" asFragment={true} />
					</Checkbox>
					<SearchField
						onChangeSelectSearchString={setSearchString}
						searchString={searchString}
						className={style.searchField}
					/>
				</div>
				{menu}
			</>
		);
	};

	return (
		<OutsideFormSelect
			testId="MultipleSelect"
			name="IDsSelectedRestaurantsForChangeDishPosition"
			label="restaurantsLabel"
			value={selectedAdditionalRestaurants}
			options={filteredRestaurants}
			fetchError={responseError}
			loading={isLoading}
			onRefetch={refetch}
			disabled={isApplyToOne || isLoading}
			onChange={setAdditionalRestaurants}
			counterValue={selectedAdditionalRestaurants.length}
			withValidation={false}
			dropdownRender={renderSelectMenu}
			mode="multiple"
		/>
	);
};

export default React.memo(MultipleSelect);
